module.exports = __webpack_public_path__ + "static/media-560-82335734c968a320135cf16cf0984b10.jpeg";